import { render, staticRenderFns } from "./brandActivity.vue?vue&type=template&id=17b721d0&scoped=true"
import script from "./brandActivity.vue?vue&type=script&lang=js"
export * from "./brandActivity.vue?vue&type=script&lang=js"
import style0 from "./brandActivity.vue?vue&type=style&index=0&id=17b721d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b721d0",
  null
  
)

export default component.exports